import { createBrowserRouter } from "react-router-dom";
import AccessMatrixContainer from "@/features/AdminPortal/components/AccessMatrixContainer";
import AdminLayout from "@/layouts/AdminLayout";
import MobileWidgetPage from "@/Pages/MobileWidgetPage";
import NoAccessPage from "@/Pages/NoAccessPage";

import ProtectedRoute from "../auth/ProtectedRoute";
import AuthLayout from "../layouts/AuthLayout";
import MainLayout from "../layouts/MainLayout";
import Dashboard from "../Pages/Dashboard";
import LoginPageWrapper from "../Pages/Login";
import AdminGuard from "./AdminGuard";
import RouterRoot from "./routerRoute";

export const router = createBrowserRouter([
  {
    element: <RouterRoot />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [
          {
            element: <MainLayout />,
            children: [{ path: "/dashboard", element: <Dashboard /> }],
          },
          {
            path: "/app/:widgetKey",
            element: <MobileWidgetPage />,
          },

          //  Separate layout for Admin
          {
            element: <AdminLayout />,
            children: [
              {
                path: "/admin-portal",
                element: (
                  <AdminGuard>
                    <AccessMatrixContainer />
                  </AdminGuard>
                ),
              },
            ],
          },
        ],
      },
      {
        element: <AuthLayout />,
        children: [
          { path: "/", element: <LoginPageWrapper /> },
          { path: "/login", element: <LoginPageWrapper /> },
        ],
      },

      {
        path: "/no-access",
        element: <NoAccessPage />,
      },
      {
        path: "*",
        element: <div style={{ padding: 20 }}>Route not found</div>,
      },
    ],
  },
]);
